import { isValidEmail } from './validation'
import { isMobileNumberValid, isValidString } from '@afterpay/utils'

interface CheckoutInitialiseLoginIdentifierData {
  crossRegionUserSignInEmail?: string
  checkoutEmail?: string | null
  checkoutMobile?: string | null
  usernameFromCookie: string | null
}

interface CheckoutInitialiseLoginIdentifier {
  email: string
  mobileNumber: string
}

export const getValidUserEmailAndMobile = ({
  crossRegionUserSignInEmail,
  checkoutEmail,
  checkoutMobile,
  usernameFromCookie,
}: CheckoutInitialiseLoginIdentifierData): CheckoutInitialiseLoginIdentifier => {
  const cachedLoginIdentifier = usernameFromCookie ?? ''
  const isCachedLoginIdentifierValid = isValidString(cachedLoginIdentifier)
  const isCachedIdentifierValidEmail = isCachedLoginIdentifierValid && isValidEmail(cachedLoginIdentifier)
  const isCachedIdentifierValidMobile = isCachedLoginIdentifierValid && isMobileNumberValid(cachedLoginIdentifier)
  const isCrossRegionEmailValid = isValidEmail(crossRegionUserSignInEmail?.trim() ?? '')

  const cachedEmail = isCachedIdentifierValidEmail ? cachedLoginIdentifier : ''
  const checkoutEmailOrCachedEmail = isValidEmail(checkoutEmail ?? '') ? checkoutEmail : cachedEmail
  const parsedEmail = isCrossRegionEmailValid ? crossRegionUserSignInEmail : checkoutEmailOrCachedEmail

  const cachedMobile = isCachedIdentifierValidMobile ? cachedLoginIdentifier : ''
  const parsedMobile = isMobileNumberValid(checkoutMobile ?? '') ? checkoutMobile : cachedMobile

  return {
    email: parsedEmail?.trim() ?? '',
    mobileNumber: parsedMobile?.trim() ?? '',
  }
}
